/**
 * Pasek podsumowania - kafelki z liczbami z GET /kontrola-faktur/podsumowanie.
 * Klikniecie kafelka z filtrem ustawia ten filtr w tabeli.
 */
import React from 'react';
import { formatujKwote } from './format';

const kafelek = ({ id, etykieta, wartosc, dopisek, kolor, tlo, filtr, aktywny, onFiltr }) => {
  const klikalny = Boolean(filtr && onFiltr);
  return (
    <div
      key={id}
      data-testid={`kafelek-${id}`}
      role={klikalny ? 'button' : undefined}
      tabIndex={klikalny ? 0 : undefined}
      onClick={klikalny ? () => onFiltr(filtr) : undefined}
      onKeyDown={klikalny ? (e) => { if (e.key === 'Enter' || e.key === ' ') onFiltr(filtr); } : undefined}
      style={{
        flex: '1 1 120px', minWidth: '120px', padding: '8px 10px', borderRadius: '6px',
        backgroundColor: tlo, borderLeft: `3px solid ${kolor}`,
        outline: aktywny ? `2px solid ${kolor}` : 'none',
        cursor: klikalny ? 'pointer' : 'default',
      }}
    >
      <div style={{ fontSize: '18px', fontWeight: 700, color: kolor, lineHeight: 1.2 }}>{wartosc}</div>
      <div style={{ fontSize: '11px', color: 'var(--text-secondary)', fontWeight: 600 }}>{etykieta}</div>
      {dopisek && <div style={{ fontSize: '11px', color: 'var(--text-muted)' }}>{dopisek}</div>}
    </div>
  );
};

const PodsumowanieKontroli = ({ liczby, aktywnyFiltr, onFiltr }) => {
  const l = liczby || {};
  const n = (k) => (l[k] === null || l[k] === undefined ? '—' : l[k]);

  const kafelki = [
    { id: 'w_portalu', etykieta: 'W portalu SFD', wartosc: n('w_portalu'), kolor: 'var(--primary)', tlo: 'var(--primary-light)', filtr: 'wszystkie' },
    { id: 'w_systemie', etykieta: 'W systemie', wartosc: n('w_systemie'), kolor: 'var(--success)', tlo: 'var(--success-light)', filtr: 'zgodne' },
    { id: 'brak_faktur', etykieta: 'Brakujące faktury', wartosc: n('brak_faktur'), dopisek: formatujKwote(l.brutto_brak_faktur), kolor: 'var(--danger)', tlo: 'var(--danger-light)', filtr: 'brak' },
    { id: 'brak_korekt', etykieta: 'Brakujące korekty', wartosc: n('brak_korekt'), dopisek: formatujKwote(l.brutto_brak_korekt), kolor: 'var(--danger)', tlo: 'var(--danger-light)', filtr: 'brak_korekty' },
    { id: 'swieze', etykieta: 'Świeże (≤ 2 dni)', wartosc: n('swieze'), kolor: 'var(--success)', tlo: 'var(--success-light)' },
    { id: 'zalegle', etykieta: 'Zaległe (> 7 dni)', wartosc: n('zalegle'), kolor: 'var(--danger)', tlo: 'var(--danger-light)' },
    { id: 'kwota_inna', etykieta: 'Inna kwota', wartosc: n('kwota_inna'), kolor: 'var(--warning)', tlo: 'var(--warning-light)', filtr: 'kwota_inna' },
    { id: 'tylko_w_systemie', etykieta: 'Tylko w systemie', wartosc: n('tylko_w_systemie'), kolor: 'var(--info)', tlo: 'var(--info-light)', filtr: 'tylko_system' },
    { id: 'duplikaty', etykieta: 'Duplikaty', wartosc: n('duplikaty'), kolor: 'var(--purple)', tlo: 'var(--purple-light)', filtr: 'duplikaty' },
    // ANEKS 2: tylko gdy cos jest podwojnie (FS i WZ) - inaczej kafelek to szum
    ...(Number(l.podwojnie) > 0
      ? [{ id: 'podwojnie', etykieta: 'Podwójnie: FS i WZ', wartosc: n('podwojnie'), kolor: 'var(--danger)', tlo: 'var(--danger-light)', filtr: 'podwojnie' }]
      : []),
  ];

  return (
    <div data-testid="podsumowanie-kontroli" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', fontSize: '12px' }}>
      {kafelki.map(k => kafelek({ ...k, aktywny: k.filtr && k.filtr === aktywnyFiltr, onFiltr }))}
    </div>
  );
};

export default PodsumowanieKontroli;
